<template>
  <svg
    version="1.1"
    id="레이어_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 80.8 71.8"
    style="enable-background:new 0 0 80.8 71.8;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M80.2,39L41.8,0.6c-0.8-0.8-2-0.8-2.8,0L0.6,39c-0.8,0.8-0.8,2,0,2.8C1,42.2,1.5,42.4,2,42.4
	c0.5,0,1-0.2,1.4-0.6l6.6-6.6v28.7c0,4.4,3.5,7.9,7.9,7.9h10.5c1.1,0,2-0.9,2-2V50.7c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10v19.1
	c0,1.1,0.9,2,2,2H63c4.4,0,7.9-3.5,7.9-7.9V35.3l6.5,6.5c0.8,0.8,2,0.8,2.8,0C81,41,81,39.8,80.2,39L80.2,39z"
    />
  </svg>
</template>

<script>
export default {
  name: 'HomeFillIcon',
};
</script>

<style scoped>
.st0 {
  fill: #3e0ba5;
}
</style>
